/**
 * 全局组件的注册
 * */
import Vue from 'vue';

Vue.component('introduce-module',()=>import('@/components/introduce'))
Vue.component('pub-breadcrumb',()=>import('@/components/PubBreadcrumb'))
